export const initialState = {
  allProducts: [],
  paymentStatus: {},
  transactionId: "",
  consultationId: "",
  vouchers: [],
  subscriptionVouchers: [],
  voucher: {},
  voucherLoading: false,
  voucherError: null,
  voucherValid: false,
  error: null,
  payError: null,
  loading: false,
  guestVoucher: {},
  guestVoucherLoading: false,
  guestVoucherError: null,
  redeemedVouchers: [],
  redeemedVoucherLoading: false,
  redeemedVoucherError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_VOUCHER":
      return {
        ...state,
        voucher: {},
        voucherValid: false,
        voucherError: null,
        guestVoucher: {},
        guestVoucherLoading: false,
        guestVoucherError: null,
      };
    case "REQUEST_LIST_VOUCHERS":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "LIST_VOUCHERS_SUCCESS":
      return {
        ...state,
        loading: false,
        vouchers: action.payload.vouchers,
        subscriptionVouchers: action.payload.subscriptionVouchers,
        nextToken: action.payload.nextToken,
      };
    case "LIST_VOUCHERS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_GET_VOUCHER":
      return {
        ...state,
        voucherLoading: true,
        voucherError: null,
        voucher: {},
        voucherValid: false,
      };
    case "GET_VOUCHER_SUCCESS":
      return {
        ...state,
        voucherLoading: false,
        voucher: action.payload.voucher,
        voucherValid: true,
      };
    case "GET_VOUCHER_ERROR":
      return {
        ...state,
        voucherLoading: false,
        voucherError: action.error,
      };
    case "LIST_CART_PRODUCTS":
      return {
        ...state,
        allProducts: [],
        loading: true,
      };
    case "LIST_CART_PRODUCTS_SUCCESS":
      return {
        ...state,
        allProducts: action.payload.allProducts,
        loading: false,
      };
    case "LIST_CART_PRODUCTS_ERROR":
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case "ADD_TO_CART":
      return {
        ...state,
        error: null,
        loading: true,
      };
    case "ADD_TO_CART_SUCCESS":
      return {
        ...state,
        allProducts: action.payload.allProducts,
        loading: false,
      };
    case "ADD_TO_CART_ERROR":
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case "REMOVE_FROM_CART":
      return {
        ...state,
        error: null,
        loading: true,
      };
    case "REMOVE_FROM_CART_SUCCESS":
      return {
        ...state,
        allProducts: action.payload.allProducts,
        loading: false,
      };
    case "REMOVE_FROM_CART_ERROR":
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case "REQUEST_LIST_PAYMENT_METHODS":
      return {
        ...state,
        error: null,
        loading: true,
      };
    case "LIST_PAYMENT_METHODS_SUCCESS":
      return {
        ...state,
        paymentStatus: action.payload.paymentStatus,
        loading: false,
      };
    case "LIST_PAYMENT_METHODS_ERROR":
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case "PAY":
      return {
        ...state,
        payError: null,
        transactionId: "",
        consultationId: "",
        loading: true,
      };
    case "PAY_SUCCESS":
      return {
        ...state,
        transactionId: action.payload.payment.transaction_id,
        consultationId: action.payload.payment.consultation_id || "",
        loading: false,
      };
    case "PAY_ERROR":
      return {
        ...state,
        payError: action.error,
        loading: false,
      };
    case "VERIFY_VOUCHER":
      return {
        ...state,
        guestVoucherError: null,
        guestVoucher: {},
        guestVoucherLoading: true,
      };
    case "VERIFY_VOUCHER_SUCCESS":
      return {
        ...state,
        guestVoucher: action.payload.voucher,
        guestVoucherLoading: false,
      };
    case "VERIFY_VOUCHER_ERROR":
      return {
        ...state,
        guestVoucherError: action.error,
        guestVoucherLoading: false,
      };
    case "REQUEST_LIST_REDEEMED_VOUCHER":
      return {
        ...state,
        redeemedVouchers: [],
        redeemedVoucherLoading: true,
        redeemedVoucherError: null,
      };
    case "LIST_REDEEMED_VOUCHER_SUCCESS":
      return {
        ...state,
        redeemedVoucherLoading: false,
        redeemedVouchers: action.payload.redeemedVouchers,
        nextToken: action.payload.nextToken,
      };
    case "LIST_REDEEMED_VOUCHER_ERROR":
      return {
        ...state,
        redeemedVoucherLoading: false,
        redeemedVoucherError: action.error,
      };
    case "CLEAR_CART":
      return {
        ...state,
        payError: null,
        loading: true,
      };
    case "CLEAR_CART_SUCCESS":
      return {
        ...state,
        allProducts: [],
        transactionId: "",
        consultationId: "",
        loading: false,
      };
    case "CLEAR_CART_ERROR":
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case "CLEAR_PAY_ERROR":
      return {
        ...state,
        payError: null,
      };
    default:
      return state;
  }
};
